<template>
<!--  礼品设置-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="基本信息" name="1">
      <van-field v-model="inputForm.name" label="名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.pointsRequired" label="所需积分" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="封面" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
<!--        <template #input>-->
<!--          <van-image v-for="item in inputForm.coverPicAttachList" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" />-->
<!--        </template>-->
      </van-field>
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in inputForm.coverPicAttachList" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(inputForm.coverPicAttachList, index)" />
      </div>
      <van-field label="图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
<!--        <template #input>-->
<!--          <van-image v-for="item in inputForm.bannerPicAttachList" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" />-->
<!--        </template>-->
      </van-field>
      <div style="display: flex; flex-wrap: wrap; padding-left: 16px">
        <van-image style="margin-right: 5px;" v-for="(item, index) in inputForm.bannerPicAttachList" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(inputForm.bannerPicAttachList, index)" />
      </div>
      <van-field label="描述" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div>
        <quill-editor :content="inputForm.description" :options="editorOption" disabled></quill-editor>
      </div>
    </van-collapse-item>
  </van-collapse>

  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {ImagePreview} from 'vant'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "giftSetting",
  data(){
    return {
      activeNames: ['1'],
      isshow: false,
      radio: '',
      inputForm:{
        isDoTask: false,
        isLastTask: false,
        name: '',
        pointsRequired: '',
        coverPicAttachList: [],
        bannerPicAttachList: [],
        description: '',
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      editorOption: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord,
    quillEditor,
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/points/wuyePointsGift/detail').then(({ data }) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(_this.inputForm, '/points/wuyePointsGift/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/points/wuyePointsGift/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(arr, index){
      ImagePreview({
        images: arr.map(item => item.url),
        startPosition: index
      })
    }
  }
}
</script>

<style scoped>

</style>